import {
  POINTS_LARGE_ICON_WIDTH,
  POINTS_SMALL_ICON_WIDTH,
} from "../range-bar/constants";
import { PositionedPoints } from "../range-bar/positioned-points";
import { RangePoint } from "../range-bar/range-point";

type StaticBarProps =
  | {
      includeNew: true;
      currentPoints: number;
      newPoints: number;
    }
  | {
      includeNew?: false;
      points: number;
    };

export function StaticBar(props: StaticBarProps): JSX.Element {
  const riskFactorPoints =
    100 - (props.includeNew ? props.currentPoints : props.points);
  const newRiskFactorPoints = 100 - (props.includeNew ? props.newPoints : 0);

  return (
    <>
      <div>
        <PositionedPoints
          points={[riskFactorPoints]}
          indicators={[
            <RangePoint
              direction="down"
              iconClassName="text-white"
              size={POINTS_SMALL_ICON_WIDTH}
              label={
                props.includeNew ? (
                  <span className="text-sm text-shale-200">Current</span>
                ) : null
              }
            />,
          ]}
        />
      </div>
      <div className=" my-1 h-2.5 health-gradient-bg rounded-lg" />
      {props.includeNew && (
        <PositionedPoints
          points={[newRiskFactorPoints]}
          indicators={[
            <RangePoint
              direction="up"
              iconClassName="text-white"
              size={POINTS_LARGE_ICON_WIDTH}
              label={<span className="text-sm text-shale-200">New</span>}
            />,
          ]}
        />
      )}
    </>
  );
}
